export default {
    optionsDialogHandler: function(toolbar) {
        toolbar.showOptionsDialog = function() {
            var a = this
              , b = this.Labels
              , c = this.popupManager.createPopup();
            c.content.classList.add("fm-popup-options");
            c.setTitle(this.osUtils.isMobile ? b.options : b.layout_options);
            c.setToolbar([{
                id: "fm-btn-apply",
                label: b.apply,
                handler: function() {
                    var r = a.pivot.getOptions()
                      , u = r.viewType
                      , x = r.grid.type;
                    r = {
                        grid: {
                            showGrandTotals: f.getValue(),
                            showTotals: g.getValue(),
                            type: h.getValue(),
                        }
                    };
                    r.viewType = x != r.grid.type && "charts" == u ? "grid" : u;
                    a.pivot.setOptions(r);
                    localStorage.setItem('repeatExpandedValues', check.getValue());
                    a.pivot.refresh()
                },
                isPositive: !0
            }, {
                id: "fm-btn-cancel",
                label: b.cancel
            }], !0);

            // Options content

            // Left column
            var e = document.createElement("div");
            e.classList.add("fm-popup-content");
            var m = document.createElement("div");
            m.classList.add("fm-ui-row");
            e.appendChild(m);

            // Grand Totals
            var k = document.createElement("div");
            k.classList.add("fm-ui-col-2");
            m.appendChild(k);
            var d = document.createElement("div");
            d.id = this.guid();
            d.classList.add("fm-title-2");
            a.setText(d, b.grand_totals);
            k.appendChild(d);
            var f = this.createRadioGroup([{
                label: b.grand_totals_off,
                value: "off"
            }, {
                label: b.grand_totals_on,
                value: "on"
            }, {
                label: b.grand_totals_on_rows,
                value: "rows"
            }, {
                label: b.grand_totals_on_columns,
                value: "columns"
            }]);
            f.setAttribute("aria-labelledby", d.id);
            k.appendChild(f);

            // Layout options
            d = document.createElement("div");
            d.id = this.guid();
            d.classList.add("fm-title-2");
            a.setText(d, b.layout);
            k.appendChild(d);
            var q = [{
                label: b.compact_view,
                value: "compact"
            }, {
                label: b.classic_view,
                value: "classic"
            }, {
                label: b.flat_view,
                value: "flat"
            }]
              , l = a.pivot.getReport({
                withDefaults: !0,
                withGlobals: !0
            });
            var h = this.createRadioGroup(q);
            h.setAttribute("aria-labelledby", d.id);
            k.appendChild(h);

            // Right column
            k = document.createElement("div");
            k.classList.add("fm-ui-col-2");
            m.appendChild(k);

            // Subtotals options
            d = document.createElement("div");
            d.id = this.guid();
            d.classList.add("fm-title-2");
            a.setText(d, b.subtotals);
            k.appendChild(d);
            var g = this.createRadioGroup([{
                label: b.subtotals_off,
                value: "off"
            }, {
                label: b.subtotals_on,
                value: "on"
            }, {
                label: b.subtotals_on_rows,
                value: "rows"
            }, {
                label: b.subtotals_on_columns,
                value: "columns"
            }]);
            h.setAttribute("aria-labelledby", d.id);
            k.appendChild(g);

            // Repeat expanded lines
            d = document.createElement("div");
            d.id = this.guid();
            d.classList.add("fm-title-2");
            a.setText(d, b.classic_view);
            k.appendChild(d);
            var lang = [...a.container.__vue__.global.localization.split('/')].pop().split('.')[0]
            var check = this.createRadioGroup([{
                label: lang === 'pt' ? "Não repetir valores expandidos" : "Don't repeat expanded values",
                value: ''
            }, {
                label: lang === 'pt' ? "Repetir valores expandidos" : "Repeat expanded values",
                value: 'true'
            }]);
            k.appendChild(check);

            c.setContent(e);
            c.initialFocusAt = f.querySelector("li");
            this.popupManager.addPopup(c);
            l = a.pivot.getOptions() || {};
            b = l.grid || {};
            f.setValue(b.showGrandTotals || "on");
            g.setValue(b.showTotals || "on");
            h.setValue(b.type || "compact");
            check.setValue(localStorage.getItem('repeatExpandedValues') || "");
        }
        ;
    }
  };